import { ErgebnisInvBedKbKomplett } from '../ws/ergebnis/gebaeude/invBedKb/ergebnis-inv-bed-kb-komplett.model';
import { Ergebnisse } from '../ws/ergebnis/ergebnisse.model';

export class TableInvBedKb {
  bezeichnung!: string;
  gesamt: number[] = [];
  jeTierplatz: number[] = [];
  gesamtAnzahlKomma: number[] = [];
  jeTierplatzAnzahlKomma: number[] = [];
  isSumme!: boolean;
  isUeberschrift!: boolean ;

  public static getTableInvBedKbList(
    ergebnisse: Ergebnisse
  ): TableInvBedKb[] {


    if (ergebnisse.ergebnisGebaeudeList.length == 0)
      return [];

    let tableInvBedKb: TableInvBedKb[] = [];

    let ergebnisInvBedKbKomplett: ErgebnisInvBedKbKomplett =
      ergebnisse.ergebnisGebaeudeList[0].ergebnisInvBedKbKomplett;

    ergebnisInvBedKbKomplett.ergebnisInvBedKbList.forEach((entry, i) => {
      let element: TableInvBedKb = new TableInvBedKb();
      element.bezeichnung = entry.kostenblock;
      element.isSumme = false;
      element.isUeberschrift = true;
      tableInvBedKb.push(element);

      entry.ergebnisInvBedKbList.forEach((entry2, j) => {
        let element: TableInvBedKb = new TableInvBedKb();
        element.bezeichnung = entry2.bezeichnung;
        element.isSumme = false;
        element.isUeberschrift = false;
        ergebnisse.ergebnisGebaeudeList.forEach((entry3) => {
          element.gesamt.push(
            entry3.ergebnisInvBedKbKomplett.ergebnisInvBedKbList[i]
              .ergebnisInvBedKbList[j].gesamt
          );
          element.jeTierplatz.push(
            entry3.ergebnisInvBedKbKomplett.ergebnisInvBedKbList[i]
              .ergebnisInvBedKbList[j].jeTierplatz
          );
          element.gesamtAnzahlKomma.push(
            entry3.ergebnisInvBedKbKomplett.ergebnisInvBedKbList[i]
              .ergebnisInvBedKbList[j].gesamtAnzahlKomma
          );
          element.jeTierplatzAnzahlKomma.push(
            entry3.ergebnisInvBedKbKomplett.ergebnisInvBedKbList[i]
              .ergebnisInvBedKbList[j].jeTierplatzAnzahlKomma
          );

        });

        tableInvBedKb.push(element);
      });

      let element2: TableInvBedKb = new TableInvBedKb();
      element2.bezeichnung = entry.ergebnisInvBedKbEinzelSumme.bezeichnung;

      element2.isSumme = true;
      element2.isUeberschrift = false;
      ergebnisse.ergebnisGebaeudeList.forEach((entry2) => {
        element2.gesamt.push(
          entry2.ergebnisInvBedKbKomplett.ergebnisInvBedKbList[i]
            .ergebnisInvBedKbEinzelSumme.gesamt
        );
        element2.jeTierplatz.push(
          entry2.ergebnisInvBedKbKomplett.ergebnisInvBedKbList[i]
            .ergebnisInvBedKbEinzelSumme.jeTierplatz
        );
        element2.gesamtAnzahlKomma.push(
          entry2.ergebnisInvBedKbKomplett.ergebnisInvBedKbList[i]
            .ergebnisInvBedKbEinzelSumme.gesamtAnzahlKomma
        );
        element2.jeTierplatzAnzahlKomma.push(
          entry2.ergebnisInvBedKbKomplett.ergebnisInvBedKbList[i]
            .ergebnisInvBedKbEinzelSumme.jeTierplatzAnzahlKomma
        );
      });

      tableInvBedKb.push(element2);
    });

    let element: TableInvBedKb = new TableInvBedKb();
    element.bezeichnung =
      ergebnisInvBedKbKomplett.ergebnisInvBedKbEinzelGesamt.bezeichnung;

    element.isSumme = true;
    element.isUeberschrift = true;
    ergebnisse.ergebnisGebaeudeList.forEach((entry) => {
      element.gesamt.push(
        entry.ergebnisInvBedKbKomplett.ergebnisInvBedKbEinzelGesamt.gesamt
      );
      element.jeTierplatz.push(
        entry.ergebnisInvBedKbKomplett.ergebnisInvBedKbEinzelGesamt.jeTierplatz
      );
      element.gesamtAnzahlKomma.push(
        entry.ergebnisInvBedKbKomplett.ergebnisInvBedKbEinzelGesamt.gesamtAnzahlKomma
      );
      element.jeTierplatzAnzahlKomma.push(
        entry.ergebnisInvBedKbKomplett.ergebnisInvBedKbEinzelGesamt.jeTierplatzAnzahlKomma
      );
    });

    tableInvBedKb.push(element);
 
    tableInvBedKb.forEach((entry) => {
      if (entry.gesamt.length > 1) {
        entry.gesamt = entry.gesamt.slice(1);
        entry.gesamtAnzahlKomma = entry.gesamtAnzahlKomma.slice(1);
        entry.jeTierplatz = entry.jeTierplatz.slice(1);
        entry.jeTierplatzAnzahlKomma = entry.jeTierplatzAnzahlKomma.slice(1);
      }
    });


    return tableInvBedKb;
  }
}
